import { skipToken } from "@reduxjs/toolkit/query/react";

import { getSessionStorage, getUser } from "@jti/rest-api";
import { useGetLoyaltyPointsQuery } from "@jti/store/slices/loyaltyApiSlice";

import { LOYALTY_CART_POINTS_STORAGE_KEY } from "@checkout-v2/features/LoyaltyPoints/utils";
import { useLoyaltyActiveStatus } from "@checkout-v2/shared/hooks/useLoyaltyActiveStatus";
import { useCheckoutV2Configuration } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";

import { OrderLoyaltyConfirmation } from "../LoyaltyConfirmation/OrderLoyaltyConfirmation";

export const OrderLoyaltyConfirmationSection = () => {
  const { loyalty, orderSummaryConfig } = useCheckoutV2Configuration();
  const hasLoyalty = useLoyaltyActiveStatus();

  const user = getUser();
  const uuid = user?.uuid;
  const ciam_token = user?.ciam_token;

  const { data: loyaltyPointsData } = useGetLoyaltyPointsQuery(uuid && ciam_token ? { uuid, ciam_token } : skipToken);
  const pendingPoints = loyaltyPointsData?.pending_points;
  const points = loyaltyPointsData?.points;

  const earnedPoints = getSessionStorage().get(LOYALTY_CART_POINTS_STORAGE_KEY, 0);
  const arrowUrl = loyalty?.orderConfirmationLoyaltyUrl;

  const shouldDisplay = hasLoyalty && earnedPoints > 0 && orderSummaryConfig?.displayLoyaltyConfirmation;

  if (!shouldDisplay) {
    return null;
  }

  return (
    <OrderLoyaltyConfirmation
      pendingPoints={pendingPoints}
      earnedPoints={earnedPoints}
      totalPoints={points}
      arrowUrl={arrowUrl}
    />
  );
};
